import { useQuery } from 'react-query';
import { fetchStripeCustomer } from '@general/api/billingAPI';

const useStripeCustomerFromAPI = ({ locale: providedLocale, memberId }) => {
    const locale = providedLocale || 'US';

    const { data, ...rest } = useQuery(
        `stripe-customer-${memberId}`,
        async () => {
            const response = await fetchStripeCustomer({ locale, memberId });
            return response?.data?.data || null;
        },
        {
            enabled: !!memberId && !!providedLocale,
            staleTime: Infinity,
        }
    );

    return { stripeCustomer: data, ...rest };
};

export default useStripeCustomerFromAPI;
